import { useEffect, useState } from 'react'; 
import Chart from './Chart';

export default function ChartBlock({type, chartdata }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`/indicateur/data/${chartdata}.json`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, [chartdata]);

  if (!data) {
    return <div className="my-4 text-gray-500">Chargement du graphique… </div>;
  }

  return <Chart data={data} type={type} />;
}